class CartCount extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("updateCart", (e) => {
      this.innerHTML =
        e.detail.cart.item_count > 0
          ? `(${e.detail.cart.item_count}) <span class="visually-hidden">Item${
              e.detail.cart.item_count === 1 ? "" : "s"
            }</span>`
          : "";
    });
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
